(function () {
  'use strict';

  if (window.BotslabPreorder) return;

  function initOffer(root) {
    if (root.dataset.bpoReady === '1') return;
    root.dataset.bpoReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bpo-service]'));
    var popups = Array.prototype.slice.call(root.querySelectorAll('[data-bpo-popup]'));
    var opener = null;

    function close() {
      popups.forEach(function (popup) {
        popup.hidden = true;
      });
      cards.forEach(function (card) {
        card.setAttribute('aria-expanded', 'false');
      });
      if (opener) opener.focus({ preventScroll: true });
      opener = null;
    }

    function open(card) {
      var key = card.dataset.bpoService;
      var target = null;
      popups.forEach(function (popup) {
        var match = popup.dataset.bpoPopup === key;
        popup.hidden = !match;
        if (match) target = popup;
      });
      cards.forEach(function (item) {
        item.setAttribute('aria-expanded', String(item === card));
      });
      if (!target) return;
      opener = card;
      var closeButton = target.querySelector('[data-bpo-popup-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    cards.forEach(function (card) {
      card.setAttribute('aria-expanded', 'false');
      card.addEventListener('click', function (event) {
        event.stopPropagation();
        if (card.getAttribute('aria-expanded') === 'true') close();
        else open(card);
      });
    });

    popups.forEach(function (popup) {
      popup.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      var button = popup.querySelector('[data-bpo-popup-close]');
      if (button) button.addEventListener('click', close);
    });

    document.addEventListener('click', function () {
      if (opener) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && opener) close();
    });
  }

  function parseDate(value) {
    var match = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((value || '').trim());
    if (!match) return null;
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])).getTime();
  }

  function initTimeline(root) {
    if (root.dataset.bpoReady === '1') return;
    root.dataset.bpoReady = '1';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-bpo-step]'));
    var fill = root.querySelector('[data-bpo-timeline-fill]');
    if (!steps.length) return;

    var mode = root.dataset.bpoActive || 'auto';
    var active = 0;
    var setProgress = Number(root.dataset.bpoProgress);
    var progress = isNaN(setProgress) ? 0.5 : Math.max(0, Math.min(1, setProgress / 100));

    if (mode === 'auto') {
      var now = parseDate(root.dataset.bpoToday);
      if (now === null) now = Date.now();
      var dates = steps.map(function (step) {
        return parseDate(step.dataset.bpoDate);
      });
      steps.forEach(function (step, index) {
        if (dates[index] !== null && dates[index] <= now) active = index;
      });
      var start = dates[active];
      var end = dates[active + 1];
      if (start !== null && end !== null && end > start && now >= start) {
        progress = Math.max(0.08, Math.min(0.92, (now - start) / (end - start)));
      }
    } else {
      active = Math.max(0, Math.min(steps.length - 1, Number(mode) - 1));
    }

    steps.forEach(function (step, index) {
      step.classList.toggle('is-active', index === active);
      step.classList.toggle('is-done', index < active);
    });

    function paint() {
      if (!fill) return;
      var track = fill.parentElement.getBoundingClientRect();
      var here = steps[active].querySelector('.bpo-step__dot').getBoundingClientRect();
      var x = here.left + here.width / 2;
      var next = steps[active + 1];
      if (next) {
        var there = next.querySelector('.bpo-step__dot').getBoundingClientRect();
        x += (there.left + there.width / 2 - x) * progress;
      } else {
        x = track.right;
      }
      fill.style.width = Math.max(0, x - track.left) + 'px';
    }

    paint();
    window.addEventListener('resize', paint);
    window.addEventListener('load', paint);
  }

  function initDrag(root) {
    if (root.dataset.bpoReady === '1') return;
    root.dataset.bpoReady = '1';

    var track = root.querySelector('[data-bpo-drag-track]');
    if (!track) return;

    var offset = 0;
    var min = 0;
    var start = null;
    var moved = false;

    function limits() {
      var view = root.getBoundingClientRect().width;
      var left = parseFloat(getComputedStyle(track).marginLeft) || 0;
      var width = track.scrollWidth;
      var centred = (view - width) / 2;
      min = Math.min(0, centred - left);
      offset = Math.max(min, Math.min(0, offset));
      apply();
      root.classList.toggle('is-draggable', min < 0);
    }

    function apply() {
      track.style.transform = 'translate3d(' + offset + 'px,0,0)';
    }

    function point(event) {
      return event.touches ? event.touches[0].clientX : event.clientX;
    }

    function down(event) {
      if (min >= 0) return;
      if (event.type === 'mousedown' && event.button !== 0) return;
      start = { x: point(event), offset: offset };
      moved = false;
      track.classList.add('is-dragging');
      if (event.type === 'mousedown') event.preventDefault();
    }

    function move(event) {
      if (!start) return;
      var dx = point(event) - start.x;
      if (Math.abs(dx) > 3) moved = true;
      offset = Math.max(min, Math.min(0, start.offset + dx));
      apply();
    }

    function up() {
      if (!start) return;
      start = null;
      track.classList.remove('is-dragging');
    }

    root.addEventListener('mousedown', down);
    root.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
    root.addEventListener('click', function (event) {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }, true);

    root.addEventListener('wheel', function (event) {
      if (min >= 0 || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      var next = Math.max(min, Math.min(0, offset - event.deltaX));
      if (next === offset) return;
      event.preventDefault();
      offset = next;
      apply();
    }, { passive: false });

    limits();
    window.addEventListener('resize', limits);
    window.addEventListener('load', limits);
    if (typeof ResizeObserver === 'function') new ResizeObserver(limits).observe(root);
  }

  function initDuo(root) {
    if (root.dataset.bpoReady === '1') return;
    root.dataset.bpoReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bpo-duo-card]'));
    if (cards.length < 2) return;
    var queued = false;

    function inset() {
      return parseFloat(getComputedStyle(root).paddingLeft) || 0;
    }

    function pick() {
      queued = false;
      var index = 0;
      var max = root.scrollWidth - root.clientWidth;
      if (max > 0 && root.scrollLeft >= max - 2) {
        index = cards.length - 1;
      } else {
        var edge = root.getBoundingClientRect().left + inset();
        var best = Infinity;
        cards.forEach(function (card, i) {
          var distance = Math.abs(card.getBoundingClientRect().left - edge);
          if (distance < best) {
            best = distance;
            index = i;
          }
        });
      }
      cards.forEach(function (card, i) {
        card.classList.toggle('is-current', i === index);
      });
    }

    root.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(pick);
    }, { passive: true });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('is-current') || root.scrollWidth <= root.clientWidth) return;
        var shift = card.getBoundingClientRect().left - root.getBoundingClientRect().left - inset();
        root.scrollTo({ left: root.scrollLeft + shift, behavior: 'smooth' });
      });
    });

    pick();
  }

  function initScrub(root) {
    if (root.dataset.bpoReady === '1') return;
    root.dataset.bpoReady = '1';

    var pin = root.querySelector('[data-bpo-scrub-pin]');
    var frame = root.querySelector('[data-bpo-scrub-frame]');
    var runway = root.querySelector('[data-bpo-scrub-runway]');
    if (!pin || !frame || !runway) return;

    var top = 0;
    var target = 0;
    var shown = 0;
    var ticking = false;
    var initial = Number(root.dataset.bpoScrubStart);
    if (!isFinite(initial)) initial = 50;
    initial = Math.max(0, Math.min(100, initial));
    var revealed = false;

    function insets() {
      var header = document.querySelector('.bfxh--stuck');
      var bar = document.querySelector('.bpo-bar');
      var above = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var below = 0;
      if (bar && document.body.classList.contains('bpo-bar-on')) {
        below = Math.max(0, window.innerHeight - bar.getBoundingClientRect().top);
      }
      return { above: above, below: below };
    }

    function place() {
      var edge = insets();
      var room = window.innerHeight - edge.above - edge.below;
      var height = pin.offsetHeight;
      var next = height <= room ? edge.above + (room - height) / 2 : window.innerHeight - edge.below - height;
      next = Math.round(next);
      if (next !== top) {
        top = next;
        pin.style.top = top + 'px';
      }
    }

    function measure() {
      var distance = runway.offsetHeight;
      if (!distance) return initial;
      var travelled = top + pin.offsetHeight - runway.getBoundingClientRect().top;
      var progress = Math.max(0, Math.min(1, travelled / distance));
      var position = 100 * progress;
      // Reset offscreen so each new entry starts at the configured split.
      if (root.getBoundingClientRect().top >= window.innerHeight) revealed = false;
      // Hold the initial split until scrolling catches up, without a jump.
      // Once revealed, reverse scrolling still covers the complete 0–100% range.
      if (position >= initial) revealed = true;
      return revealed ? position : initial;
    }

    function paint(value) {
      shown = value;
      frame.style.setProperty('--pf-compare-pos', value.toFixed(3) + '%');
    }

    function step() {
      ticking = false;
      var gap = target - shown;
      if (target === 0 || target === 100 || Math.abs(gap) < 0.05) {
        paint(target);
        return;
      }
      paint(shown + gap * 0.22);
      ticking = true;
      requestAnimationFrame(step);
    }

    function update() {
      place();
      target = measure();
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(step);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('header:scrolled', update);
    if (typeof ResizeObserver === 'function') new ResizeObserver(update).observe(pin);

    place();
    target = measure();
    paint(target);
  }

  function planProperties(plan) {
    var price = Number(plan.bpoPrice) || 0;
    var properties = { _is_selling_plan: 'true' };
    if (plan.bpoDeposit) {
      var deposit = Number(plan.bpoDeposit) || 0;
      var balance = plan.bpoBalance ? Number(plan.bpoBalance) : price - deposit;
      properties['_PRE-ORDER DEPOSIT'] = (deposit / 100).toFixed(2);
      properties['_REMAINING BALANCE'] = (balance / 100).toFixed(2);
    } else if (price) {
      properties['_FULL-PARTIAL DEPOSIT'] = (price / 100).toFixed(2);
      properties._sd_tag = 'sd-fullpartial';
    }
    return properties;
  }

  function checkoutPlan(plan, qty, routes, button, error) {
    var item = { id: Number(plan.bpoVariant), quantity: qty };
    if (plan.bpoPlan) {
      item.selling_plan = Number(plan.bpoPlan);
      item.properties = planProperties(plan);
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    fetch(routes.bpoCartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          window.location.href = routes.bpoCheckout || '/checkout';
        });
      })
      .catch(function (data) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (error) {
          error.textContent = (data && (data.description || data.message)) || 'Something went wrong. Please try again.';
          error.hidden = false;
        }
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-bpo-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    var wrap = button.parentNode;
    var error = wrap && wrap.querySelector('[data-bpo-add-error]');
    checkoutPlan(button.dataset, 1, button.dataset, button, error);
  });

  function initBar(root) {
    if (root.dataset.bpoReady === '1') return;
    root.dataset.bpoReady = '1';

    var input = root.querySelector('[data-bpo-qty-input]');
    var priceSets = Array.prototype.slice.call(root.querySelectorAll('[data-bpo-price-set]'));
    var submit = root.querySelector('[data-bpo-bar-submit]');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-bpo-bar-option]'));
    var error = root.querySelector('[data-bpo-bar-error]');

    function quantity() {
      var value = parseInt(input && input.value, 10);
      return isNaN(value) || value < 1 ? 1 : value;
    }

    function current() {
      for (var i = 0; i < options.length; i += 1) {
        if (options[i].checked) return options[i];
      }
      return options[0] || null;
    }

    function sync() {
      var option = current();
      if (!option) {
        if (submit) submit.disabled = true;
        return;
      }
      priceSets.forEach(function (set) {
        set.hidden = set.dataset.bpoPriceSet !== option.value;
      });
      if (error) error.hidden = true;
      if (submit) submit.disabled = !option.dataset.bpoVariant || option.dataset.bpoAvailable !== 'true';
    }

    root.querySelectorAll('[data-bpo-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!input) return;
        input.value = Math.max(1, quantity() + Number(button.dataset.bpoQty));
      });
    });

    if (input) {
      input.addEventListener('change', function () {
        input.value = quantity();
      });
    }

    options.forEach(function (option) {
      option.addEventListener('change', sync);
    });

    if (submit) {
      submit.addEventListener('click', function () {
        var option = current();
        if (!option || submit.disabled) return;
        checkoutPlan(option.dataset, quantity(), root.dataset, submit, error);
      });
    }

    function reserve() {
      document.documentElement.style.setProperty('--bpo-bar-h', root.offsetHeight + 'px');
    }

    document.body.classList.add('bpo-bar-on');
    reserve();
    window.addEventListener('resize', reserve);
    if (typeof ResizeObserver === 'function') new ResizeObserver(reserve).observe(root);

    sync();
  }

  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-bpo-offer]').forEach(initOffer);
    context.querySelectorAll('[data-bpo-timeline]').forEach(initTimeline);
    context.querySelectorAll('[data-bpo-drag]').forEach(initDrag);
    context.querySelectorAll('[data-bpo-duo]').forEach(initDuo);
    context.querySelectorAll('[data-bpo-bar]').forEach(initBar);
    context.querySelectorAll('[data-bpo-scrub]').forEach(initScrub);
  }

  window.BotslabPreorder = { boot: boot };

  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('[data-bpo-bar]')) document.body.classList.remove('bpo-bar-on');
  });
})();
